import { render, staticRenderFns } from "./classesStudentView.vue?vue&type=template&id=e8508f12&scoped=true&"
import script from "./classesStudentView.vue?vue&type=script&lang=js&"
export * from "./classesStudentView.vue?vue&type=script&lang=js&"
import style0 from "./classesStudentView.vue?vue&type=style&index=0&id=e8508f12&prod&lang=scss&scoped=true&"
import style1 from "./classesStudentView.vue?vue&type=style&index=1&id=e8508f12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8508f12",
  null
  
)

export default component.exports